<div class="stats-card">
    <h4 class="stats-label">{{ label }}</h4>
    <h3 class="stats-value">{{value }}</h3>
</div>